
import { WorldCountry } from '../types';

// Fase 12 - Expansión Asia: Países del Sudeste Asiático expandidos
export const asiaExpansion12: WorldCountry[] = [
  // Singapur expandido (Fase 12)
  {
    name: 'Singapore',
    slug: 'singapore',
    code: 'SG',
    population: 5850342,
    topCities: [
      { name: 'Singapore', slug: 'singapore-city', population: 5850342 },
      { name: 'Jurong East', slug: 'jurong-east', population: 72000 },
      { name: 'Woodlands', slug: 'woodlands', population: 254730 },
      { name: 'Tampines', slug: 'tampines', population: 284315 },
      { name: 'Sengkang', slug: 'sengkang', population: 249370 },
      { name: 'Punggol', slug: 'punggol', population: 195000 },
      { name: 'Jurong West', slug: 'jurong-west', population: 263886 },
      { name: 'Ang Mo Kio', slug: 'ang-mo-kio', population: 174370 },
      { name: 'Bedok', slug: 'bedok', population: 289412 },
      { name: 'Hougang', slug: 'hougang', population: 226805 },
      { name: 'Choa Chu Kang', slug: 'choa-chu-kang', population: 190430 },
      { name: 'Yishun', slug: 'yishun', population: 220775 },
      { name: 'Toa Payoh', slug: 'toa-payoh', population: 128000 },
      { name: 'Pasir Ris', slug: 'pasir-ris', population: 143593 },
      { name: 'Sembawang', slug: 'sembawang', population: 89000 },
      { name: 'Bukit Batok', slug: 'bukit-batok', population: 149680 },
      { name: 'Bukit Panjang', slug: 'bukit-panjang', population: 139000 },
      { name: 'Geylang', slug: 'geylang', population: 103500 },
      { name: 'Kallang', slug: 'kallang', population: 92500 },
      { name: 'Marine Parade', slug: 'marine-parade', population: 86000 },
      { name: 'Queenstown', slug: 'queenstown', population: 101200 },
      { name: 'Clementi', slug: 'clementi', population: 91500 },
      { name: 'Bishan', slug: 'bishan', population: 87000 },
      { name: 'Serangoon', slug: 'serangoon', population: 120000 },
      { name: 'Novena', slug: 'novena', population: 62000 },
      { name: 'Orchard', slug: 'orchard', population: 58000 },
      { name: 'City Hall', slug: 'city-hall', population: 45000 },
      { name: 'Marina Bay', slug: 'marina-bay', population: 52000 },
      { name: 'Chinatown', slug: 'chinatown-singapore', population: 39000 },
      { name: 'Little India', slug: 'little-india', population: 41000 },
      { name: 'Bugis', slug: 'bugis', population: 47000 },
      { name: 'Clarke Quay', slug: 'clarke-quay', population: 28000 },
      { name: 'Boat Quay', slug: 'boat-quay', population: 31000 },
      { name: 'Robertson Quay', slug: 'robertson-quay', population: 35000 },
      { name: 'Dhoby Ghaut', slug: 'dhoby-ghaut', population: 38000 },
      { name: 'Somerset', slug: 'somerset', population: 42000 },
      { name: 'Raffles Place', slug: 'raffles-place', population: 49000 },
      { name: 'Tanjong Pagar', slug: 'tanjong-pagar', population: 67000 },
      { name: 'Harbourfront', slug: 'harbourfront', population: 72000 },
      { name: 'Sentosa', slug: 'sentosa', population: 1890 },
      { name: 'Buona Vista', slug: 'buona-vista', population: 45000 },
      { name: 'Dover', slug: 'dover', population: 38000 },
      { name: 'Commonwealth', slug: 'commonwealth', population: 52000 },
      { name: 'Redhill', slug: 'redhill', population: 47000 },
      { name: 'Tiong Bahru', slug: 'tiong-bahru', population: 59000 },
      { name: 'Outram Park', slug: 'outram-park', population: 43000 },
      { name: 'Lavender', slug: 'lavender', population: 36000 },
      { name: 'Boon Lay', slug: 'boon-lay', population: 68000 },
      { name: 'Pioneer', slug: 'pioneer', population: 54000 },
      { name: 'Joo Koon', slug: 'joo-koon', population: 42000 },
      { name: 'Gul Circle', slug: 'gul-circle', population: 35000 },
      { name: 'Tuas Crescent', slug: 'tuas-crescent', population: 28000 },
      { name: 'Tuas West Road', slug: 'tuas-west-road', population: 31000 },
      { name: 'Tuas Link', slug: 'tuas-link', population: 26000 },
      { name: 'Expo', slug: 'expo', population: 38000 },
      { name: 'Changi', slug: 'changi', population: 45000 },
      { name: 'Tanah Merah', slug: 'tanah-merah', population: 67000 },
      { name: 'Simei', slug: 'simei', population: 83000 },
      { name: 'Kembangan', slug: 'kembangan', population: 72000 },
      { name: 'Eunos', slug: 'eunos', population: 58000 },
      { name: 'Paya Lebar', slug: 'paya-lebar', population: 76000 },
      { name: 'Aljunied', slug: 'aljunied', population: 64000 },
      { name: 'Dakota', slug: 'dakota', population: 52000 },
      { name: 'MacPherson', slug: 'macpherson', population: 48000 },
      { name: 'Tai Seng', slug: 'tai-seng', population: 42000 },
      { name: 'Bartley', slug: 'bartley', population: 47000 },
      { name: 'Kovan', slug: 'kovan', population: 53000 },
      { name: 'Potong Pasir', slug: 'potong-pasir', population: 41000 },
      { name: 'Boon Keng', slug: 'boon-keng', population: 38000 },
      { name: 'Farrer Park', slug: 'farrer-park', population: 44000 },
      { name: 'Braddell', slug: 'braddell', population: 49000 },
      { name: 'Lorong Chuan', slug: 'lorong-chuan', population: 46000 },
      { name: 'Marymount', slug: 'marymount', population: 52000 },
      { name: 'Caldecott', slug: 'caldecott', population: 47000 },
      { name: 'Botanic Gardens', slug: 'botanic-gardens', population: 43000 },
      { name: 'Tan Kah Kee', slug: 'tan-kah-kee', population: 39000 },
      { name: 'Sixth Avenue', slug: 'sixth-avenue', population: 41000 },
      { name: 'King Albert Park', slug: 'king-albert-park', population: 45000 },
      { name: 'Beauty World', slug: 'beauty-world', population: 48000 },
      { name: 'Hillview', slug: 'hillview', population: 52000 },
      { name: 'Upper Bukit Timah', slug: 'upper-bukit-timah', population: 46000 },
      { name: 'Cashew', slug: 'cashew', population: 43000 },
      { name: 'Phoenix LRT', slug: 'phoenix-lrt', population: 39000 },
      { name: 'Bukit Panjang LRT', slug: 'bukit-panjang-lrt', population: 41000 },
      { name: 'Petir LRT', slug: 'petir-lrt', population: 37000 },
      { name: 'Pending LRT', slug: 'pending-lrt', population: 35000 },
      { name: 'Bangkit LRT', slug: 'bangkit-lrt', population: 38000 },
      { name: 'Fajar LRT', slug: 'fajar-lrt', population: 41000 },
      { name: 'Segar LRT', slug: 'segar-lrt', population: 44000 },
      { name: 'Jelapang LRT', slug: 'jelapang-lrt', population: 42000 },
      { name: 'Senja LRT', slug: 'senja-lrt', population: 45000 },
      { name: 'Ten Mile Junction LRT', slug: 'ten-mile-junction-lrt', population: 38000 },
      { name: 'South View LRT', slug: 'south-view-lrt', population: 36000 },
      { name: 'Keat Hong LRT', slug: 'keat-hong-lrt', population: 40000 },
      { name: 'Teck Whye LRT', slug: 'teck-whye-lrt', population: 42000 },
      { name: 'Choa Chu Kang LRT', slug: 'choa-chu-kang-lrt', population: 47000 },
      { name: 'Yew Tee', slug: 'yew-tee', population: 51000 },
      { name: 'Kranji', slug: 'kranji', population: 46000 },
      { name: 'Marsiling', slug: 'marsiling', population: 89000 },
      { name: 'Admiralty', slug: 'admiralty', population: 63000 },
      { name: 'Canberra', slug: 'canberra', population: 58000 },
      { name: 'Sembawang', slug: 'sembawang-north', population: 52000 },
      { name: 'Yio Chu Kang', slug: 'yio-chu-kang', population: 67000 },
      { name: 'Khatib', slug: 'khatib', population: 74000 },
      { name: 'Yishun Central', slug: 'yishun-central', population: 81000 },
      { name: 'Northpoint', slug: 'northpoint', population: 69000 },
      { name: 'Springleaf', slug: 'springleaf', population: 56000 }
    ]
  },
  // Laos (Fase 12)
  {
    name: 'Laos',
    slug: 'laos',
    code: 'LA',
    population: 7275560,
    topCities: [
      { name: 'Vientiane', slug: 'vientiane', population: 948477 },
      { name: 'Pakse', slug: 'pakse', population: 88332 },
      { name: 'Savannakhet', slug: 'savannakhet', population: 120000 },
      { name: 'Luang Prabang', slug: 'luang-prabang', population: 56049 },
      { name: 'Thakhek', slug: 'thakhek', population: 85000 },
      { name: 'Phonsavan', slug: 'phonsavan', population: 37507 },
      { name: 'Muang Xay', slug: 'muang-xay', population: 38992 },
      { name: 'Saravan', slug: 'saravan', population: 38000 },
      { name: 'Attapeu', slug: 'attapeu', population: 20000 },
      { name: 'Houayxay', slug: 'houayxay', population: 18123 },
      { name: 'Phongsali', slug: 'phongsali', population: 21000 },
      { name: 'Xam Neua', slug: 'xam-neua', population: 38992 },
      { name: 'Salavan', slug: 'salavan', population: 22600 },
      { name: 'Sekong', slug: 'sekong', population: 23000 },
      { name: 'Xamtai', slug: 'xamtai', population: 15000 },
      { name: 'Muang Kham', slug: 'muang-kham', population: 12000 },
      { name: 'Xaignabouli', slug: 'xaignabouli', population: 62092 },
      { name: 'Muang Sing', slug: 'muang-sing', population: 13500 },
      { name: 'Boun Neua', slug: 'boun-neua', population: 11200 },
      { name: 'Tha Bo', slug: 'tha-bo', population: 9800 }
    ]
  },
  // Camboya (Fase 12)
  {
    name: 'Cambodia',
    slug: 'cambodia',
    code: 'KH',
    population: 16718965,
    topCities: [
      { name: 'Phnom Penh', slug: 'phnom-penh', population: 1573544 },
      { name: 'Siem Reap', slug: 'siem-reap', population: 245494 },
      { name: 'Battambang', slug: 'battambang', population: 196709 },
      { name: 'Sihanoukville', slug: 'sihanoukville', population: 199902 },
      { name: 'Poipet', slug: 'poipet', population: 43366 },
      { name: 'Kampong Cham', slug: 'kampong-cham', population: 63771 },
      { name: 'Ta Khmau', slug: 'ta-khmau', population: 52066 },
      { name: 'Pursat', slug: 'pursat', population: 52476 },
      { name: 'Kampong Speu', slug: 'kampong-speu', population: 33231 },
      { name: 'Kampong Thom', slug: 'kampong-thom', population: 32485 },
      { name: 'Kratie', slug: 'kratie', population: 38215 },
      { name: 'Stung Treng', slug: 'stung-treng', population: 26665 },
      { name: 'Pailin', slug: 'pailin', population: 12000 },
      { name: 'Kep', slug: 'kep', population: 40280 },
      { name: 'Banlung', slug: 'banlung', population: 23100 },
      { name: 'Senmonorom', slug: 'senmonorom', population: 7944 },
      { name: 'Kampot', slug: 'kampot', population: 48000 },
      { name: 'Lumphat', slug: 'lumphat', population: 19205 },
      { name: 'Suong', slug: 'suong', population: 23967 },
      { name: 'Baray', slug: 'baray', population: 16135 },
      { name: 'Sisophon', slug: 'sisophon', population: 99019 },
      { name: 'Samraong', slug: 'samraong', population: 22153 },
      { name: 'Anlong Veng', slug: 'anlong-veng', population: 23000 },
      { name: 'Preah Vihear', slug: 'preah-vihear', population: 15000 },
      { name: 'Tbong Khmum', slug: 'tbong-khmum', population: 45000 }
    ]
  }
];
